import * as resolver from './resolver';
import baseResolver from './baseResolver';
import roleIdentifierComparator from './roleIdentifierComparator';
import isRootUserId from './isRootUserId';

const { authenticatedResolver } = resolver;

export {
  resolver,
  authenticatedResolver,
  baseResolver,
  roleIdentifierComparator,
  isRootUserId,
};
